// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../../index'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import ToiletCheckQuestionForm from './ToiletCheckQuestionForm'
import type { ToiletCheckQuestion } from './toiletCheckQuestionTypes'
import css from './toiletCheckQuestionDialog.css'
type Props = {
  data: ToiletCheckQuestion | null | undefined
  isOpen: boolean
  onClose: (...args: Array<any>) => any
}

class ToiletCheckQuestionDialog extends React.Component<Props> {
  render() {
    const { data, stationId, isOpen, onClose } = this.props
    return (
      <Dialog open={isOpen} onClose={onClose} aria-labelledby='form-dialog-title' className={css.component}>
        <DialogTitle id='form-dialog-title'>
          {data && data.id
            ? i18n.t('admin.toiletCheckQuestions.updateDialogTitle')
            : i18n.t('admin.toiletCheckQuestions.createDialogTitle')}
        </DialogTitle>
        <DialogContent>
          <ToiletCheckQuestionForm data={data} stationId={stationId} onSubmit={onClose} onCancel={onClose} />
        </DialogContent>
      </Dialog>
    )
  }
}

export default ToiletCheckQuestionDialog
